export const RESOURCE_TYPE_NEXTGEN_BACKLOG_REST_RESOURCE = 'NEXTGEN_BACKLOG_REST';
export const RESOURCE_TYPE_NEXTGEN_BACKLOG_REST_RESOURCE_OLD = 'NEXTGEN_BACKLOG_REST_OLD';
export const RESOURCE_TYPE_NEXTGEN_BACKLOG_CONFIG_DATA = 'NEXTGEN_BACKLOG_CONFIG_DATA';
export const RESOURCE_TYPE_NEXTGEN_BACKLOG_GLOBAL_CONFIG_DATA =
	'NEXTGEN_BACKLOG_GLOBAL_CONFIG_DATA';
